// extracted by mini-css-extract-plugin
export default {"mCard":"NE-z","image":"OE-z","imageNoBackground":"PE-z","imageHasCategory":"QE-z","fullWidth":"RE-z"};